import React, { type ReactNode } from 'react';

type Props = {
	children: ReactNode;
};

export const PanelGroup = ({ children }: Props) => <>{children}</>;
